import { Effect, Layer, Queue, Result, Scope } from "effect";
import { OPEN_FLOW_RECORDING_EVENT } from "./events.ts";
import { recordingCrossLinkFailure, type RecordingCrossLinkObservation } from "./crosslink-model.ts";
import { RecordingCrossLinkIo } from "./crosslink-service.ts";

export const RecordingCrossLinkIoLive = Layer.succeed(RecordingCrossLinkIo, RecordingCrossLinkIo.of({ events: (admission, channel = "Selection", canRead = () => true) => Effect.gen(function* () {
  const owner = yield* Scope.Scope;
  const alive = () => admission.state._tag !== "Closed" && owner.state._tag !== "Closed" && canRead();
  if (!alive()) return yield* Effect.interrupt;
  const queue = yield* Effect.acquireRelease(Queue.unbounded<RecordingCrossLinkObservation>(), Queue.shutdown);
  const page = yield* Effect.try({ try: () => typeof window === "undefined" ? undefined : window, catch: recordingCrossLinkFailure });
  const receive = (event: Event) => {
    if (!alive()) return;
    if (channel === "Announcement") { Queue.offerUnsafe(queue, { _tag: "Announced" });return; }
    const result = Result.try(() => {
      const detail: unknown = (event as CustomEvent<unknown>).detail;
      if (!detail || typeof detail !== "object") return undefined;
      const value = detail as Record<string, unknown>;
      return {
        workspaceId: typeof value.workspaceId === "string" && value.workspaceId ? value.workspaceId.toLowerCase() : null,
        sessionId: typeof value.sessionId === "string" ? value.sessionId : null,
        recordingId: typeof value.recordingId === "string" ? value.recordingId : null
      };
    });
    if (Result.isFailure(result)) Queue.offerUnsafe(queue, { _tag: "Failed", failure: recordingCrossLinkFailure(result.failure) });
    else if (result.success !== undefined) Queue.offerUnsafe(queue, { _tag: "Open", value: result.success });
  };
  if (page) {
    yield* Effect.addFinalizer(() => Effect.try({ try: () => page.removeEventListener(OPEN_FLOW_RECORDING_EVENT, receive), catch: recordingCrossLinkFailure }).pipe(Effect.orDie));
    yield* Effect.try({ try: () => page.addEventListener(OPEN_FLOW_RECORDING_EVENT, receive), catch: recordingCrossLinkFailure });
  }
  return queue;
}) }));
